import { render, staticRenderFns } from "./LegacyRedirect.vue?vue&type=template&id=0f29b549&scoped=true&"
import script from "./LegacyRedirect.vue?vue&type=script&lang=ts&"
export * from "./LegacyRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29b549",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
